import { apiClient } from './client'
import type { MeResponseDTO } from './types'

/** All auth endpoints rely on HttpOnly cookies — no tokens ever cross JS. */

export interface LoginPayload {
  email: string
  password: string
  organization_slug?: string
}

export const authApi = {
  /**
   * Hydrate "who am I" from the session cookie. Throws ``UnauthorizedError``
   * when the cookie is missing or invalid.
   */
  me: (signal?: AbortSignal) =>
    apiClient.get<MeResponseDTO>('/api/v1/auth/me', undefined, signal),

  /** Open a session. On success, the backend sets HttpOnly cookies. */
  login: (payload: LoginPayload) =>
    apiClient.post<MeResponseDTO>('/api/v1/auth/login', payload, {
      skipAuthRefresh: true,
    }),

  /** Revoke current session + clear cookies. Idempotent. */
  logout: () =>
    apiClient.post<{ ok: boolean }>('/api/v1/auth/logout', undefined, {
      skipAuthRefresh: true,
    }),
}
